var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "div",
        { staticClass: "lanaya-dialog" },
        [
          _c("div", { staticClass: "lanaya-dialog__background" }),
          _vm._v(" "),
          _c(
            "transition",
            {
              attrs: { name: "dialog" },
              on: {
                "after-leave": _vm.afterLeave,
                "after-enter": _vm.afterEnter
              }
            },
            [
              _vm.wrapperVisible
                ? _c(
                    "div",
                    {
                      staticClass: "lanaya-dialog__wrapper",
                      style: _vm.widthStyle
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "lanaya-dialog__wrapper__header" },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "lanaya-dialog__wrapper__header__title"
                            },
                            [_vm._v(_vm._s(_vm.title))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "lanaya-dialog__wrapper__header__close",
                              on: { click: _vm.closeDialog }
                            },
                            [_c("i", { staticClass: "icon icon-close" })]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "lanaya-dialog__wrapper__body" },
                        [
                          _vm._t("default", [
                            _vm._v("\n          default body\n        ")
                          ])
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "lanaya-dialog__wrapper__footer" },
                        [
                          _vm._t("foot", [
                            _vm._v("\n          default footer\n        ")
                          ])
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2cbca0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2cbca0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/dialog/Dialog.vue
// module id = 93
// module chunks = 0